import * as React from 'react';
import { RATIO } from 'mm-theme-configuration/dist/consts';
import { LazyImage } from '../lazyImage/LazyImage';
import { createImageAspectRatios, getImageSrcAndSrcSet, ImageWidths } from '../image.utils';
import { EagerImage } from '../eagerImage/EagerImage';
import { MandatoryAdditionalStyle } from '../../../components.utils';
import { Thumbnail } from '../image.types';
import { ImageWithFigcaptionWrapper } from './ImageWithFigcaptionWrapper';

export interface ImageDataProps {
    lazyLoad?: boolean;
    aspectRatio?: RATIO;
    figcaption: string;
    dataId?: string;
    imageWidths: ImageWidths;
}
type ImageProps = ImageDataProps & MandatoryAdditionalStyle & Thumbnail;

export const ImageWithFigcaption: React.FunctionComponent<ImageProps> = props => {
  const { host, path, description, aspectRatio = { x: 16, y: 9 }, additionalStyle, lazyLoad, figcaption, dataId, imageWidths } = props;
  const CalculatedImage = lazyLoad ? LazyImage : EagerImage;
  const { fallbackSrc, lowResUrl, srcSetLargeScreen, srcSetMediumScreen, srcSetSmallScreen } = getImageSrcAndSrcSet(createImageAspectRatios(aspectRatio, aspectRatio, aspectRatio), imageWidths, host, path);
  return (
    <ImageWithFigcaptionWrapper aspectRatio={aspectRatio} additionalStyle={additionalStyle} figcaption={figcaption} dataId={dataId}>
      <CalculatedImage fallbackSrc={fallbackSrc} title={description} lowResUrl={lowResUrl} alt={description} srcSetLargeScreen={srcSetLargeScreen} srcSetMediumScreen={srcSetMediumScreen} srcSetSmallScreen={srcSetSmallScreen} />
    </ImageWithFigcaptionWrapper>
  );
};
